import { alertController } from '@ionic/vue';
import capacitorConstant from '../../constants/capacitor.constant';

const alertGeolocationPermissionIssue = () => new Promise((resolve) => {
  alertController
    .create({
      header: capacitorConstant.permissionAlert.geoLocationError.title,
      message: capacitorConstant.permissionAlert.geoLocationError.message,
      buttons: [
        {
          text: 'Ok',
          handler() {
            resolve(false);
          },
        },
      ],
    })
    .then((alert) => {
      alert.present();
    });
});

export { alertGeolocationPermissionIssue };
